import { SVGProps } from "react";

export const Checkmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#E2DFD7" />
    <path
      stroke="#383838"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m5.5 10 3 3 6-6"
    />
  </svg>
);
